import type * as React from "react";

import { cn } from "../lib/cn";

export interface EmptyNoteProps extends React.HTMLAttributes<HTMLParagraphElement> {
  /** One sentence in Brian's voice (DESIGN.md): "Nothing in this room." */
  children: React.ReactNode;
  ref?: React.Ref<HTMLParagraphElement>;
}

/** Empty-list line; fills its container. Failures are `PanelError`, loads `Skeleton`. */
export function EmptyNote({ children, className, ...rest }: EmptyNoteProps) {
  return (
    <p
      className={cn(
        "flex h-full items-center justify-center p-10 text-sm text-annotation",
        className,
      )}
      {...rest}
    >
      {children}
    </p>
  );
}
